<template>
  <el-dialog
    :modelValue="modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    width="1295px"
    :show-close="false"
    style="background-color: #0c1a35"
  >
    <template #header="{ close, titleId, titleClass }">
      <span :id="titleId" :class="titleClass">
        <img src="@/assets/img/chatGPT.png" width="50" />
        chatGPT
      </span>
      <el-button class="el-dialog__headerbtn" @click="close">
        <el-icon class="el-icon--left"><Close /></el-icon>
      </el-button>
    </template>
    <div class="container">
      <div class="tips">
        <span>
          您当前账号总次数为{{ userInfo.chatgpt_total }}次，已使用{{
            userInfo.chatgpt_used
          }}次，剩余{{ userInfo.chatgpt_total - userInfo.chatgpt_used }}次
        </span>
        <el-button class="hover" @click="clearHandle" :disabled="loading">
          清空对话
        </el-button>
      </div>
      <div class="content_list" ref="scrollRef">
        <div
          class="item"
          v-for="(item, index) in reactiveData.messages"
          :key="index"
        >
          <div class="user" v-if="item.role === 'user'">
            <div class="icon">
              <img src="@/assets/img/chatGPT_icon_q.png" />
            </div>
            <div class="content">{{ item.content }}</div>
          </div>
          <div class="assistant" v-else-if="item.role === 'assistant'">
            <div class="icon">
              <img src="@/assets/img/chatGPT_icon_a.png" />
            </div>
            <div class="content" v-html="item.content"></div>
            <div class="tools">
              <span class="t1 hover" @click="copyHandle(item.content)">
                复制
              </span>
              <span
                class="t2 hover"
                @click="updateHandle(index)"
                :disabled="loading"
              >
                <img src="@/assets/img/chatGPT_icon_update.png" />
                更新
              </span>
            </div>
          </div>
        </div>
        <div class="item" v-show="loading">
          <div class="assistant">
            <div class="icon">
              <img src="@/assets/img/chatGPT_icon_a.png" />
            </div>
            <div class="content">
              <el-icon class="is-loading"><Loading /></el-icon>
            </div>
          </div>
        </div>
      </div>
      <el-form
        class="form"
        ref="formRef"
        :model="formData"
        :rules="rules"
        hide-required-asterisk
        @submit.stop.prevent="submitForm(formRef)"
      >
        <el-form-item prop="keyword">
          <div class="input">
            <el-input v-model="formData.keyword" placeholder="" type="search" />
            <el-button
              class="submit hover"
              @click="submitForm(formRef)"
              :loading="loading"
              :disabled="loading"
            >
              <img src="@/assets/img/chatGPT_icon_submit.png" />
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script setup>
import { toRefs, ref, reactive, watch, nextTick } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { copyText } from 'vue3-clipboard'
import { chatGPT } from '@/utils/api'
import { Close, Loading } from '@element-plus/icons-vue'

const store = useStore()
const { state } = store
const { loading, userInfo } = toRefs(state)

const props = defineProps({
  modelValue: { type: Boolean },
})
const { modelValue } = toRefs(props)

const emit = defineEmits(['update:modelValue'])

const formRef = ref()

const rules = reactive({
  keyword: [{ required: true, message: '请输入', trigger: 'blur' }],
})

const reactiveData = reactive({
  messages: [
    { role: 'system', content: '请用中文来回复我' },
    // { role: 'user', content: '制作app流程' },
    // {
    //   role: 'assistant',
    //   content:
    //     '确定应用的功能和需求：包括应用的目的、面向对象、目标受众以及应用包含的功能和特色等。 设计应用的界面和布局：根据应用的特点、用户人群和用户的使用习惯，进行页面布局、交互流程设计和UI设计。',
    // },
  ],
})

const formData = reactive({
  keyword: '',
})

const scrollRef = ref(null)
const scrollHandle = () => {
  if (scrollRef.value) {
    scrollRef.value.scrollTop = scrollRef.value.scrollHeight
  }
}
watch(loading, () => {
  if (loading.value) {
    nextTick(scrollHandle)
  }
})

const submitHandle = async () => {
  const { data: res } = await chatGPT(
    { messages: reactiveData.messages },
    {
      timeout: 36e5,
    }
  )
  reactiveData.messages.push(res.data.choices[0].message)
  nextTick(scrollHandle)
}

const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      reactiveData.messages.push({ role: 'user', content: formData.keyword })
      formData.keyword = ''
      submitHandle()
    } else {
      console.log('error submit!', fields)
    }
  })
}

const copyHandle = (value) => {
  copyText(value, undefined, (error, event) => {
    if (error) {
      ElMessage.error('复制失败')
    } else {
      ElMessage.success('复制成功')
    }
  })
}

const clearHandle = () => {
  reactiveData.messages = []
}

const updateHandle = async (index) => {
  reactiveData.messages.splice(index)
  submitHandle()
}
</script>

<style lang="scss" scoped>
.el-dialog__title {
  padding-left: 50px;
  font-size: 32px;
  display: flex;
  align-items: center;
  img {
    margin-right: 15px;
  }
}
.container {
  .tips {
    margin-bottom: 30px;
    padding-left: 50px;
    padding-right: 17px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 18px;
      color: #fff;
    }
    .el-button {
      border-color: #fd5050;
      background-color: #fd5050;
      color: #fff;
      width: 91px;
      height: 33px !important;
    }
  }
  .content_list {
    margin-left: -20px;
    margin-right: -20px;
    height: 430px;
    overflow-x: hidden;
    .item {
      .flex {
        display: flex;
        align-items: center;
        min-height: 88px;
        color: #fff;
        .icon {
          padding-left: 70px;
        }
        .content {
          padding: 20px 30px !important;
          line-height: 24px !important;
          white-space: pre-wrap;
        }
      }
      .user {
        background-color: #222e43;
        @extend .flex;
        font-size: 24px;
        font-weight: bold;
      }
      .assistant {
        background-color: #0f182a;
        @extend .flex;
        font-size: 18px;
        padding-bottom: 50px;
        position: relative;
        .content {
          padding-top: 30px !important;
        }
        .tools {
          position: absolute;
          right: 50px;
          bottom: 0;
          z-index: 9;
          height: 50px;
          display: flex;
          align-items: center;
          .t1 {
            cursor: pointer;
            display: flex;
            align-items: center;
            color: #49ffcd;
          }
          .t2 {
            margin-left: 28px;
            cursor: pointer;
            display: flex;
            align-items: center;
            color: #49b9ff;
            img {
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
  .form {
    padding: 30px 50px 0;
    display: flex;
    align-items: center;
    .el-form-item {
      margin-bottom: 0;
    }
    .el-form-item,
    .input {
      width: 100%;
    }
    :deep(.el-input__wrapper) {
      background: #364663;
      height: 65px;
      padding-right: 80px;
      .el-input__inner {
        font-size: 18px;
      }
    }
    .submit {
      position: absolute;
      right: 0;
      border: 0;
      height: 65px !important;
      padding: 8px 25px;
    }
  }
}
</style>
